<template>
	<div v-if="loading" class="loader-wrapper">
		<UILoader />
	</div>

	<template v-else>
		<LoginLayout v-if="!loggedIn" @get-me="getMe()" />
		<DefaultLayout v-else />
	</template>
</template>

<script setup>
import {
	onMounted,
	ref,
	provide,
	reactive,
	computed,
	onBeforeUnmount,
} from 'vue'
import { useToggle } from '@vueuse/core'
import { useBreakpoints } from '@/composables/use-breakpoints'
import { UserService } from '@/services/user-service'
import Translations from '@/i18n/translation'
import DefaultLayout from '@/layout/DefaultLayout'
import LoginLayout from '@/layout/LoginLayout'
import UILoader from '@/components/ui/UILoader/index.vue'
import { useNotification } from '@/composables/use-notification'

const loading = ref(false)
const toggleLoading = useToggle(loading)

const me = reactive({ login: '', id: '', role: '' })
const loggedIn = computed(() => !!me.id)

const updateMe = info => {
	me.login = info.login
	me.id = info.id
	me.role = info.role
}

const getMe = async () => {
	const resp = await UserService.getMe()
	if (!resp) return

	localStorage.setItem('role', resp.role)
	updateMe(resp)
}

provide('me', { me, updateMe })
provide('logged', loggedIn)

const breakpoints = useBreakpoints()

provide('isXl', breakpoints.isXl)
provide('isLg', breakpoints.isLg)
provide('isMd', breakpoints.isMd)
provide('isSm', breakpoints.isSm)
provide('isXs', breakpoints.isXs)
provide('isHXl', breakpoints.isHXl)
provide('isHLg', breakpoints.isHLg)
provide('isHMd', breakpoints.isHMd)
provide('isHSm', breakpoints.isHSm)
provide('isHXs', breakpoints.isHXs)
provide('breakpointHorizontal', breakpoints.breakpointHorizontal)

const { withdrawalsEventStream, listenWorker, initializeSSE, destroySSE } =
	useNotification()

onMounted(async () => {
	toggleLoading(true)

	await getMe()
	await Translations.switchLanguage(Translations.guessDefaultLocale())

	breakpoints.setCssVars()
	window.addEventListener('resize', breakpoints.onResize())

	toggleLoading(false)

	if (window.SharedWorker) {
		listenWorker()
	} else {
		initializeSSE()
	}
})

onBeforeUnmount(() => {
	window.removeEventListener('resize', breakpoints.onResize())

	if (withdrawalsEventStream) {
		destroySSE()
	}
})
</script>
